import { render, staticRenderFns } from "./MessageBoxList.vue?vue&type=template&id=bad724c4&"
import script from "./MessageBoxList.vue?vue&type=script&lang=ts&"
export * from "./MessageBoxList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports